import { initArticleSrcLinkComponent } from './ArticleSrcLink/ArticleSrcLink';
export { default as ThemeIcon } from './shared/Icon/Icon.vue';
export { default as ThemeButton } from './shared/Button/Button.vue';
export { default as ThemeButtonGroup } from './shared/ButtonGroup/ButtonGroup.vue';
export { default as ThemeLoader } from './shared/Loader/Loader.vue';
export { default as ThemeProgressBar } from './shared/ProgressBar/ProgressBar.vue';
export { default as ThemeFormField } from './shared/forms/FormField.vue';
export { default as ThemeFormRow } from './shared/forms/FormRow.vue';
export { default as ThemeModal } from './shared/Modal/Modal.vue';
import ThemeModal from './shared/Modal/Modal.vue';
import { createApp } from 'vue';
export function initComponents() {
    initArticleSrcLinkComponent();
}
/**
 * Creates a generic modal.
 * Returns a handler that allows to show show/dismiss the modal,
 * as well as to use a promise that would resolve with a value returned by the action handler.
 */
export function createGenericModal(args) {
    const el = document.createElement('div');
    document.body.appendChild(el);
    let resolver;
    const app = createApp(ThemeModal, Object.assign({}, args, {
        afterDismissed: (response) => {
            var _a;
            app.unmount();
            (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(el);
            if (typeof resolver === 'function') {
                resolver(response);
            }
        },
    }));
    const instance = app.mount(el);
    return {
        /**
         * Returns a promise that resolves when the modal is dismissed.
         * The promise resolves with the value returned by the action handler.
         */
        dismissed() {
            return new Promise(resolve => {
                resolver = resolve;
            });
        },
        /**
         * Shows the modal.
         * Returns a function that can be used to dismiss the modal.
         */
        show() {
            instance.show();
            return () => instance.dismiss();
        }
    };
}
